import request from "@/axios";

/** 分页查询播放器参数项配置 */
export const getPlayConfigList = query => {
  return request({
    url: "/lebo-desk/player/params/list",
    method: "GET",
    params: query
  });
};

/** 删除播放器参数项配置 */
export const deletePlayConfig = ids => {
  return request({
    url: `/lebo-desk/player/params/delete?ids=` + ids,
    method: "DELETE"
  });
};

/** 保存播放器参数项配置 */
export const savePlayConfig = payload => {
  return request({
    url: "/lebo-desk/player/params/add",
    method: "POST",
    data: payload
  });
};

/** 更新播放器参数项配置 */
export const updatePlayConfig = payload => {
  return request({
    url: "/lebo-desk/player/params/update",
    method: "PUT",
    data: payload
  });
};
